import layoutHeaderAside from '@/layouts/HeaderAside'
const meta = { auth: true }
export default {
  path: '/certificate',
  name: 'certificate',
  meta,
  component: layoutHeaderAside,
  children: [
    // {
    //   path: '/certificate/index',
    //   name: 'certificate-index',
    //   component: () => import('@/pages/certificate/index.vue'),
    //   meta: {
    //     ...meta,
    //     title:'打印电子领货凭证'
    //   }
    // },
    // {
    //   path: '/certificate/second',
    //   name: 'certificate-second',
    //   component: () => import('@/pages/certificate/second.vue'),
    //   meta: {
    //     ...meta,
    //     title:'打印电子领货凭证'
    //   }
    // },
    {
      path: '/certificate/result',
      name: 'certificate-result',
      component: () => import('@/pages/certificate/result.vue'),
      meta: {
        ...meta,
        title:'货物运单'
      }
    }
  ]
}
